import React from 'react'

const Footers = () => {
    return (
        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0">© {new Date().getFullYear()} Voxel. All Rights Reserved.</p>
            </div>
            <div className="col-auto">
              <p className="mb-0">
                Made by <span className="text-primary-600">Voxel</span>
              </p>
            </div>
          </div>
        </footer>
    );
}
 
export default Footers;